// extracted by mini-css-extract-plugin
export default {"dataSecurityWraper":"dataSecurity_dataSecurityWraper__RnTqB","dataSecurityContent":"dataSecurity_dataSecurityContent__InQwA"};